/**
 * Mapping api endpoints to it's matching key as will be reported to BI.
 *
 * @type {Object<string>}
 */
export const ApiEndpoint = {
    CREATE: 'create',
    CREATE_REQUEST_TO_ORDER: 'create_request_to_order'
};

/**
 * API context as it's reported to BI.
 *
 * @type {string}
 */
export const API_CONTEXT = 'messages';
